<template>
  <div class="page-user">
    <div class="y-header">


      <p class="fortune_coin-label">当前能量</p>
      <h5 class="fortune_coin-num">{{ $store.state.user.coinNum }}</h5>
      <van-button color="linear-gradient(90deg, #FFCC2E 0%, #EDB11A 100%)"
                  v-show="activityStatus==='1'"
                  size="small"
                  @click="toExChange"
                  class="yui_btn-to-exchange"
                  round>立即兑换
      </van-button>

      <div class="yui_desc2">
        <van-icon class="y-icon" name="warning"
                  color="#117A28"/>
        <span>6月30日24时清零</span>
      </div>
      <!--      <van-row type="flex">
              <van-col span="12">
                <div class="money_num">
                  <div>
                    324 <span>个</span>
                  </div>
                  <div class="money_num-label">
                    当前能量
                  </div>

                </div>
              </van-col>
              <van-col span="12">

                <div class="y-link-exchange" @click="toExChange">
                  立即兑换
                </div>

                <div class="y-desc-end">
                  活动最后一天24点，能量清零。
                </div>


              </van-col>
            </van-row>-->
    </div>

    <div class="yui_card-tabs">
      <div class="y-tabs-hd">
        <div class="y-tabs-hd-item"
             @click="tabsChange(1)"
             :class="{active:tabsIndex===1}">已获得
        </div>
        <div class="y-tabs-hd-item"
             @click="tabsChange(2)"
             :class="{active:tabsIndex===2}">已兑换
        </div>
      </div>
      <div class="y-tabs-bd">

        <van-list
            v-model="loading"
            :finished="finished"
            :finished-text="list.length>0?'没有更多了':'没有记录哦'"
            @load="onLoad"
        >
          <!--          <van-cell v-for="item in list" :key="item" :title="item"/>-->
          <van-cell class="y_cell"
                    v-for="(item,index) in list"
                    :key="'k_'+index"
                    :title="item.remark||'消费'"
                    :value="item.coinNum"
                    size="large"
                    :class="{coinAdd:tabsIndex===1,coinDel:tabsIndex===2}"
                    :label="item.time|timeFilter"/>


          <img v-show="list.length===0" style="width: 36vw;margin: 10vw auto 0;display: block;"
               src="../../assets/zanwujiaofeijilu@3x.png" alt="">

        </van-list>


        <!--        <div class="yui_preview-log">
                  <div class="yui_cell">
                    <div class="yui-log-name">
                      2元优惠券
                    </div>
                    <div class="yui-log-num">
                      -1
                    </div>
                  </div>
                  <div class="yui-time">
                    2021.03.22
                  </div>
                </div>-->


      </div>
    </div>


  </div>
</template>

<script>
import {
  findCoinLogList, isVaildActivity
} from "@/services/api";
import {ygetDate} from "@/libs/tools";

export default {
  name: "user-fortune-coin",
  data() {
    return {
      tabsIndex: 1,
      list: [],
      loading: false,
      finished: false,
      page: 1,
      pageSize: 10,
      activityStatus: ''

    }
  },
  filters: {
    timeFilter(val) {
      return ygetDate(val, 'date')
    }
  },
  mounted() {
    this.$store.dispatch('handGetUserCoinInfo', {
      token: this.$store.state.user.token,
      deviceCoding: this.$store.state.user.deviceCoding
    }).then(res => {
      console.log(res)

    }).catch(err => {
      this.$toast(err)
      console.error(err)
    })
    this.getActivityStatus(this.$store.state.user.token, this.$store.state.user.deviceCoding)
  },
  methods: {
    getActivityStatus(token, deviceCoding) {
      let robj = new FormData();
      let that = this
      robj.append('token', token)
      robj.append('deviceCoding', deviceCoding)
      robj.append('activityNo', this.$store.state.activityNo)
      isVaildActivity(robj).then(res => {
        console.log(res)
        if (res.respcod === '01') {
          /*
          0-未开始，
          1-进行中，
          2-已结束，
          3-不存在
          */
          that.activityStatus = res.data.status
          // that.logList = res.data


        } else {
          this.$toast(res.respmsg)
        }


      }).catch(onerror => {
        console.error(onerror)
        this.$toast('网络错误')
      })
    },
    tabsChange(i) {
      if (this.loading) {
        return false;
      }
      this.tabsIndex = i
      this.list = []
      this.page = 1
      this.loading = true;
      this.finished = false;
      this.onLoad()
    },
    toExChange() {
      this.$router.push({
        name: 'Exchange'
      })
    },
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      /*      setTimeout(() => {
              for (let i = 0; i < 10; i++) {
                this.list.push(this.list.length + 1);
              }

              // 加载状态结束
              this.loading = false;

              // 数据全部加载完成
              if (this.list.length >= 40) {
                this.finished = true;
              }
            }, 1000);*/
      let that = this
      this.getLogList(that.tabsIndex, that.page, that.pageSize).then(res => {
        console.log(res)

        let oList = []
        if (that.page !== 1) {
          oList = that.list
        }
        if (JSON.stringify(res.data) === '{}') {
          that.loading = false;
          that.finished = true;
          return false;
        }
        that.page = that.page + 1
        that.list = oList.concat(res.data)
        that.loading = false;
        if (res.data.length === 0) {
          that.finished = true;
        }
      }).catch(err => {
        console.log(err)
      })

    },

    getLogList(type, page, size) {

      return new Promise((resolve, reject) => {
        try {
          let robj = new FormData();

          robj.append('token', this.$store.state.user.token)
          robj.append('deviceCoding', this.$store.state.user.deviceCoding)
          robj.append('page', page)
          robj.append('size', size)
          robj.append('type', type)

          findCoinLogList(robj).then(res => {
            if (res.respcod === '01') {
              resolve(res)
            } else {
              reject(res.respmsg)
            }

          }).catch(err => {
            console.error(err)
            reject('网络错误')
          })

        } catch (e) {
          console.log(e)
          reject('cw')
        }
      })


    }
  }

}
</script>

<style lang="less" scoped>
.y-header {
  padding: 5vw 0 0;
  height: 30vw;
  //background-color: #de7f1b;
  color: #ffffff;
  position: relative;

  .fortune_coin-label {
    margin: 0;
    font-size: 3vw;

  }

  .fortune_coin-num {
    font-size: 10vw;
    margin: 2vw 0;
    font-weight: 500;

  }

  .yui_btn-to-exchange {
    padding-left: 5vw;
    padding-right: 5vw;
  }

  .yui_desc2 {
    position: absolute;
    display: flex;
    align-items: center;
    font-size: 3vw;
    top: 5vw;
    right: 3vw;
    line-height: 1;
color: #117A28;
    .y-icon {
      font-size: 3vw;
      transform: scale(1.2);
    }

    span {
      margin-left: 0.3em;
    }
  }
}

.page-user {
  background-image: url("../../assets/bg-top-w.png");
  background-size: 100% auto;
  background-position: center top;
  background-repeat: no-repeat;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.yui_card-tabs {
  flex: 1;
  position: relative;
  margin: 3vw;
  padding: 3vw;
  background-color: #ffffff;
  border-radius: 3vw;

  .y-tabs-hd {
    display: flex;
    align-items: center;
    padding-bottom: 2vw;

    .y-tabs-hd-item {
      flex: 1;
      font-size: 4vw;

      &.active {
        position: relative;
        color: #2FBD4B;

        &:after {
          position: absolute;
          content: " ";
          width: 5vw;
          height: 0.6vw;
          top: 1.5em;
          border-radius: 0.8vw;
          left: calc(50% - 2.5vw);
          background-color: #2FBD4B;
        }
      }
    }

  }

  .y-tabs-bd {
    height: calc(100vh - 60vw);
    overflow-y: scroll;
  }
}

.money_num-label {
  font-size: 14px;
  margin-top: 10px;
}

.y-link-exchange {
  font-size: 12px;
}

.y-desc-end {
  font-size: 10px;
  margin-top: 10px;
}

.yui_list-item {
  display: flex;
  padding: 10px 15px;
  align-items: center;
  font-size: 14px;

  .item-hd {
    font-size: 16px;
    color: #de7f1b;
    font-weight: 700;
  }

  .item-bd {
    flex: 1;
    font-size: 16px;
  }

  .item-ft {
    font-size: 12px;
    color: #999;
  }
}


.yui_preview-log {
  text-align: left;
  padding: 3vw 3vw;
  position: relative;

  .yui_cell {
    display: flex;
    align-items: center;


    .yui-log-name {
      flex: 1;
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      line-height: 20px;
    }

    .yui-log-num {

      font-size: 14px;
      font-weight: 400;
      color: #999999;
      line-height: 20px;
    }
  }

  .yui-time {
    font-size: 12px;
    font-weight: 400;
    color: #999999;
    line-height: 17px;
  }

  &:after {
    position: absolute;
    content: " ";
    bottom: 0;
    left: 0;
    right: 0;
    border-bottom: 1px solid #E6E6E6;
  }

  &:last-child:after {
    border: none;
  }
}

.y_cell {
  text-align: left;

  .van-cell__title {

    font-size: 14px;
    font-weight: 400;
    color: #999999;
  }

  .van-cell__label {
    font-size: 12px;
  }

  .van-cell__value {
    flex: initial;
  }
}

.coinAdd {
  .van-cell__value {
    color: #2FBD4B;

    span {
      &:before {
        content: "+";
      }
    }
  }
}

.coinDel {
  .van-cell__value {
    color: #999999;

    span {
      &:before {
        content: "-";
      }
    }
  }
}
</style>